// Current feature guides and bounded, dated examples from the shared native chart renderer.
export const serviceGroups = [
  { key: 'realestate', label: '부동산 분석', items: [
    { key: 'value', title: '저평가지수', icon: 'mdi-scale-balance', question: '관심 지역의 가격, 다른 기준으로 보면 어떨까요?', description: '소득, 전세, 구매력 같은 기준을 가격과 함께 살펴보세요. 하나의 수치보다 여러 지표를 나란히 보는 데 도움이 됩니다.', points: ['소득 대비 주택가격', '전세와 매매의 관계', '지역 간 지표 비교'], query: '저평가' },
    { key: 'price', title: '지수/가격통계', icon: 'mdi-chart-line', question: '어느 지역의 가격이 어떻게 움직였을까요?', description: '매매·전세 가격과 지수를 지역별로 비교하세요. 같은 기간의 흐름을 보면 관심 지역의 변화를 파악하기 쉽습니다.', points: ['매매·전세 가격 흐름', '지역별 가격지수', '기간별 변화 비교'], query: '가격' },
    { key: 'supply', title: '수요/공급', icon: 'mdi-home-city-outline', question: '앞으로 들어올 집과 아직 남은 집은 얼마나 될까요?', description: '입주물량과 미분양, 거래 동향을 함께 확인하세요. 관심 지역의 가격과 수급을 연결해서 살펴볼 수 있습니다.', points: ['입주물량', '미분양', '수급·거래 동향'], query: '수요공급' },
    { key: 'apartment', title: '단지분석', icon: 'mdi-office-building-outline', question: '마음에 둔 아파트를 조금 더 자세히 볼까요?', description: '지역을 정했다면 개별 단지의 시세와 거래를 살펴보세요. 주변 단지를 함께 비교하며 후보를 좁혀갈 수 있습니다.', points: ['단지별 시세', '실제 거래 흐름', '주변 단지 비교'], query: '단지' },
    { key: 'trade', title: '실거래가', icon: 'mdi-chart-scatter-plot', question: '실제로는 얼마에 거래되고 있을까요?', description: '관심 지역과 단지의 실제 거래가격을 확인하세요. 거래 시점과 조건을 함께 보며 시세와 비교할 수 있습니다.', points: ['실제 거래가격', '거래 시점', '지역·단지별 비교'], query: '실거래' },
    { key: 'gap', title: '갭투자', icon: 'mdi-swap-horizontal', question: '매매가격과 전세가격의 차이는 얼마나 될까요?', description: '매매와 전세의 가격 차이, 전세가율을 함께 비교하세요. 관심 지역과 아파트의 가격 구조를 이해할 수 있습니다.', points: ['매매·전세 차이', '전세가율', '지역별 비교'], query: '갭' },
    { key: 'region', title: '지역별', icon: 'mdi-map-marker-radius-outline', question: '어느 지역부터 살펴보면 좋을까요?', description: '시도에서 시군구, 읍면동으로 관심 범위를 좁혀보세요. 지역별 주요 지표를 살펴본 뒤 원하는 단지 분석으로 이어갈 수 있습니다.', points: ['시도·시군구 분석', '읍면동 비교', '지역 종합 지표'], query: '지역별' },
    { key: 'theme', title: '테마별', icon: 'mdi-account-group-outline', question: '가격 말고 어떤 변화를 함께 볼 수 있을까요?', description: '교통 이용량과 지역 규제 등 지역을 이해하는 데 필요한 지표를 살펴보세요. 가격 차트만으로 알기 어려운 배경을 함께 확인할 수 있습니다.', points: ['교통 이용량', '지역 규제 현황', '공시가격 조건'], query: '테마' }
  ] },
  { key: 'economy', label: '경제 분석', items: [
    { key: 'global', title: '경제 지표 비교', icon: 'mdi-earth', question: '부동산을 둘러싼 경제의 큰 흐름은 어떨까요?', description: '관심 있는 경제 지표를 고르고 흐름을 비교해 보세요. 단일 지표부터 두 지표의 시각적 비교, 상관관계 분석으로 이어갈 수 있습니다.', points: ['단일 지표', '두 지표 비교', '상관관계 분석'], query: '' },
    { key: 'us', title: '미국 경제', icon: 'mdi-chart-areaspline', question: '미국의 경제와 금융시장은 어떻게 움직일까요?', description: '미국의 경제·금융·부동산 관련 지표를 살펴보세요. 국내 시장을 볼 때 함께 참고할 경제 환경을 확인할 수 있습니다.', points: ['경제지표', '금융시장', '부동산 지표'], query: '미국' },
    { key: 'korea', title: '한국 경제', icon: 'mdi-bank-outline', question: '우리 경제와 아파트 시장을 함께 볼까요?', description: '한국의 경기, 통화량과 아파트 시장 관련 지표를 살펴보세요. 시장의 움직임을 더 넓은 맥락에서 이해할 수 있습니다.', points: ['경기 흐름', '통화량·금리', '아파트 시장과 경제 규모'], query: '한국' }
  ] }
];

export const serviceSteps = [
  { title: '시도', description: '전국에서 관심 지역 찾기', query: '시도' },
  { title: '시군구', description: '지역의 가격과 수급 비교', query: '시군구' },
  { title: '읍면동', description: '내가 살 동네 더 살펴보기', query: '읍면동' },
  { title: '단지', description: '관심 아파트 자세히 보기', query: '단지' }
];

export const servicePreviews = {
  value: { panels: ['pir', 'hai'], title: '통합 차트 · 소득과 구매력으로 보는 가격 부담', note: '서울의 소득 대비 주택가격과 KB 주택구매력지수 예시입니다. 지표별 관측 주기가 다릅니다.' },
  price: { panels: ['price', 'jeonse'], title: '통합 차트 · 가격과 전세', note: '서울의 리치고 평당 매매·전세 시세와 별도 제공되는 전세가율입니다.' },
  supply: { panels: ['supply', 'unsold'], title: '통합 차트 · 입주와 미분양', note: '서울의 연간 입주물량과 월별 미분양입니다. 진행·예정 물량은 색상으로 구분합니다.' },
  gap: { panels: ['jeonse'], title: '함께 볼 지표 · 전세가율', note: '서울의 전세가율 예시입니다. 개별 단지의 갭 금액과 조건 검색은 관련 상세 분석에서 확인하세요.' },
  region: { panels: ['transactions', 'listings'], title: '통합 차트 · 지역의 거래와 매물', note: '서울의 매매 거래량과 매물량입니다. 최근 월 거래량은 신고가 추가될 수 있습니다.' },
  korea: { panels: ['m2', 'gdp'], title: '통합 차트 · 경제 규모와 아파트 시장', note: 'M2 통화량 및 분기 GDP 대비 아파트 시가총액 비율입니다. 지표마다 마지막 관측 월이 다릅니다.' }
};

// Guide links go through catalogue search, retaining menu availability and membership checks.
export const serviceGuides = {
  "apartment": [
    {
      "title": "단지분석 차트",
      "description": "관심 아파트의 지표를 한곳에서 확인",
      "path": "/realestate?q=%EB%8B%A8%EC%A7%80%EB%B6%84%EC%84%9D%20%EC%B0%A8%ED%8A%B8",
      "level": "고급"
    },
    {
      "title": "매물지수(단지별, 주간)",
      "description": "단지별 매물의 주간 변화 살펴보기",
      "path": "/realestate?q=%EB%A7%A4%EB%AC%BC%EC%A7%80%EC%88%98(%EB%8B%A8%EC%A7%80%EB%B3%84%2C%20%EC%A3%BC%EA%B0%84)",
      "level": "고급"
    },
    {
      "title": "지역별 평당가격10분위 및 단지리스트 1",
      "description": "지역 안에서 가격대별 단지 찾기",
      "path": "/realestate?q=%EC%A7%80%EC%97%AD%EB%B3%84%20%ED%8F%89%EB%8B%B9%EA%B0%80%EA%B2%A910%EB%B6%84%EC%9C%84%20%EB%B0%8F%20%EB%8B%A8%EC%A7%80%EB%A6%AC%EC%8A%A4%ED%8A%B8%201",
      "level": "고급"
    }
  ],
  "trade": [
    {
      "title": "실거래가격",
      "description": "실제로 거래된 가격 확인",
      "path": "/realestate?q=%EC%8B%A4%EA%B1%B0%EB%9E%98%EA%B0%80%EA%B2%A9",
      "level": "일반"
    },
    {
      "title": "실거래(가격/량) 세부분석",
      "description": "가격과 거래량을 세부 조건으로 살펴보기",
      "path": "/realestate?q=%EC%8B%A4%EA%B1%B0%EB%9E%98(%EA%B0%80%EA%B2%A9%2F%EB%9F%89)%20%EC%84%B8%EB%B6%80%EB%B6%84%EC%84%9D",
      "level": "일반"
    },
    {
      "title": "거래회전율 및 지역내 거래비중",
      "description": "거래가 얼마나 활발한지 비교",
      "path": "/realestate?q=%EA%B1%B0%EB%9E%98%ED%9A%8C%EC%A0%84%EC%9C%A8%20%EB%B0%8F%20%EC%A7%80%EC%97%AD%EB%82%B4%20%EA%B1%B0%EB%9E%98%EB%B9%84%EC%A4%91",
      "level": "고급"
    }
  ],
  "theme": [
    {
      "title": "시간대별 승하차수",
      "description": "시간대별 지하철 이용 흐름 확인",
      "path": "/realestate?q=%EC%8B%9C%EA%B0%84%EB%8C%80%EB%B3%84%20%EC%8A%B9%ED%95%98%EC%B0%A8%EC%88%98",
      "level": "일반"
    },
    {
      "title": "정부규제 지역현황",
      "description": "지역별 규제 현황 살펴보기",
      "path": "/realestate?q=%EC%A0%95%EB%B6%80%EA%B7%9C%EC%A0%9C%20%EC%A7%80%EC%97%AD%ED%98%84%ED%99%A9",
      "level": "프리미엄"
    },
    {
      "title": "공시가격 1억/3억미만 투자",
      "description": "공시가격 조건에 맞는 단지 찾기",
      "path": "/realestate?q=%EA%B3%B5%EC%8B%9C%EA%B0%80%EA%B2%A9%201%EC%96%B5%2F3%EC%96%B5%EB%AF%B8%EB%A7%8C%20%ED%88%AC%EC%9E%90",
      "level": "프리미엄"
    }
  ],
  "global": [
    {
      "title": "단일지표(베타오픈)",
      "description": "궁금한 경제 지표의 흐름 확인",
      "path": "/economy?q=%EB%8B%A8%EC%9D%BC%EC%A7%80%ED%91%9C(%EB%B2%A0%ED%83%80%EC%98%A4%ED%94%88)",
      "level": "일반"
    },
    {
      "title": "지표간 시각적 상관관계분석(베타오픈)",
      "description": "선택한 두 지표를 나란히 비교",
      "path": "/economy?q=%EC%A7%80%ED%91%9C%EA%B0%84%20%EC%8B%9C%EA%B0%81%EC%A0%81%20%EC%83%81%EA%B4%80%EA%B4%80%EA%B3%84%EB%B6%84%EC%84%9D(%EB%B2%A0%ED%83%80%EC%98%A4%ED%94%88)",
      "level": "일반"
    },
    {
      "title": "상관관계 높은 지표간 분석(베타오픈)",
      "description": "미리 선정된 지표 사이의 관계 살펴보기",
      "path": "/economy?q=%EC%83%81%EA%B4%80%EA%B4%80%EA%B3%84%20%EB%86%92%EC%9D%80%20%EC%A7%80%ED%91%9C%EA%B0%84%20%EB%B6%84%EC%84%9D(%EB%B2%A0%ED%83%80%EC%98%A4%ED%94%88)",
      "level": "일반"
    }
  ],
  "us": [
    {
      "title": "경제 지표",
      "description": "미국 경기 관련 지표 살펴보기",
      "path": "/economy?q=%EB%AF%B8%EA%B5%AD%20%EA%B2%BD%EC%A0%9C%20%EC%A7%80%ED%91%9C",
      "level": "일반"
    },
    {
      "title": "부동산 지표",
      "description": "미국 주택시장의 흐름 확인",
      "path": "/economy?q=%EB%AF%B8%EA%B5%AD%20%EB%B6%80%EB%8F%99%EC%82%B0%20%EC%A7%80%ED%91%9C",
      "level": "일반"
    },
    {
      "title": "금융 지표",
      "description": "금리·채권·통화량 등 금융 지표 확인",
      "path": "/economy?q=%EB%AF%B8%EA%B5%AD%20%EA%B8%88%EC%9C%B5%20%EC%A7%80%ED%91%9C",
      "level": "일반"
    }
  ]
};
